import { archive, slug } from './catalogue';

function PublicArticle({item}) {
  const website = item.www && (/^https?:\/\//i.test(item.www) ? item.www : `https://${item.www}`);
  return <article class="archive-article"><h2>{item.title}</h2>
    {item.image && <a href={item.image} data-lightbox="article"><img src={item.image} alt={item.title} loading="lazy" /></a>}
    {item.body.split(/\n\s*\n/).map((text,index)=><p class="preserve-lines" key={index}>{text}</p>)}
    {website && <p><a href={website} rel="noopener noreferrer" target="_blank">{item.www}</a></p>}
    {item.email && <p><a href={`mailto:${item.email}`}>{item.email}</a></p>}
  </article>;
}
export function ArchiveContent({location}) {
  const items = archive.content.filter(item=>item.location === location).sort((a,b)=>b.date.localeCompare(a.date));
  return <><h1>{location === 'blog' ? 'News' : location}</h1>{items.map(item=>location === 'blog'
    ? <article class="archive-article" key={item.id}><h2><a href={`/blog/see_news/${slug(item.title)}/${item.id}`}>{item.title}</a></h2><p>{item.body.slice(0,300)}…</p></article>
    : <PublicArticle key={item.id} item={item} />)}</>;
}
export function NewsArticle({item}) {
  return <><h1>News</h1><PublicArticle item={item}/><p><a href="/blog">← All news</a></p></>;
}
